import { Search, DraftingCompass, Rocket, Wrench } from "lucide-react";

const steps = [
  {
    icon: Search,
    num: "01",
    title: "Discovery Call",
    desc: "We learn your business, your clients, and the processes eating your time. You pick a plan or a one-time build.",
  },
  {
    icon: DraftingCompass,
    num: "02",
    title: "Design & Build",
    desc: "Our team designs and develops your website and/or app — professional, fast, and built around your workflow.",
  },
  {
    icon: Rocket,
    num: "03",
    title: "Launch",
    desc: "We deploy, test, and put your platform live. Your business goes from invisible to undeniable.",
  },
  {
    icon: Wrench,
    num: "04",
    title: "Manage & Improve",
    desc: "Subscribers get ongoing updates, changes, and support — with response speed based on your tier's priority.",
  },
];

export default function HowItWorks() {
  return (
    <section id="process" className="circuit-bg relative border-t border-white/5 bg-[#050505] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#00f0ff]">// How it works</p>
          <h2 className="font-display mt-4 text-3xl font-black tracking-tight sm:text-4xl">
            From first call to <span className="text-[#ff003c] text-glow-magenta">full throttle</span>
          </h2>
        </div>

        <div className="relative mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-12 hidden h-px bg-gradient-to-r from-[#00f0ff]/40 via-white/10 to-[#ff003c]/40 lg:block" />
          {steps.map((s) => (
            <article
              key={s.num}
              data-testid={`process-step-${s.num}`}
              className="group relative border border-white/10 bg-black p-8 transition-colors duration-300 hover:border-[#00f0ff]/40"
            >
              <span className="font-mono-tech absolute right-6 top-6 text-4xl font-bold text-white/5 transition-colors duration-300 group-hover:text-[#00f0ff]/15">
                {s.num}
              </span>
              <div className="flex h-12 w-12 items-center justify-center border border-[#00f0ff]/40 bg-[#00f0ff]/5">
                <s.icon size={20} className="text-[#00f0ff]" strokeWidth={1.75} />
              </div>
              <h3 className="font-display mt-6 text-base font-bold">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/50">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
